// extracted by mini-css-extract-plugin
export default {"dialogContent":"CreditCheckPdfViewer_dialogContent__jQiSL","pdfContainer":"CreditCheckPdfViewer_pdfContainer__jkxxs","pdfViewer":"CreditCheckPdfViewer_pdfViewer__L1ktL"};